/* eslint-disable @typescript-eslint/no-namespace */
import { DealType, DealVersion } from '../../types/deal.types';

export namespace DealTypeVersion {
  export function isCompetitive(deal: DealVersion): boolean {
    return hasDealType(deal)
      ? getDealType(deal) === DealType.competitive
      : false;
  }

  export function isNegotiated(deal: DealVersion): boolean {
    return hasDealType(deal)
      ? getDealType(deal) === DealType.negotiated
      : false;
  }

  export function isPrivatePlacement(deal: DealVersion): boolean {
    return hasDealType(deal)
      ? getDealType(deal) === DealType.privatePlacement
      : false;
  }

  export function getDealType(deal: DealVersion): DealType {
    return deal && deal.dealType;
  }

  export function hasDealType(deal: DealVersion): boolean {
    return !!(deal && deal.dealType);
  }
}
